import { useFormik } from "formik";
import { maskEmail, maskPhoneNumber } from "../../../../../helperFunctions";
import { SingleCooperative } from "../../../../../redux/features/cooperative/cooperative.type";
import { useInitiateCooperativeWalletWithdrawalMutation } from "../../../../../redux/features/finances/finances.api";
import { useAppSelector } from "../../../../../redux/hooks";
import { Button } from "../../../../buttons/button";
import { InformationCard } from "../../../../cards/infoCard";
import { TextInput } from "../../../../inputs/textInput";

export const StepThree = ({
  amount,
  cooperativeDetails,
  onSuccess,
}: {
  amount: number;
  cooperativeDetails: SingleCooperative;
  onSuccess: () => void;
}) => {
  const [initiateWithdrawal, { isLoading: initiatingWithdrawal }] =
    useInitiateCooperativeWalletWithdrawalMutation();

  const profile = useAppSelector((state) => {
    return state.auth.profile;
  });

  const { handleBlur, touched, errors, values, handleChange, handleSubmit } =
    useFormik({
      initialValues: {
        code: "",
      },
      onSubmit: async (values) => {
        const resp = await initiateWithdrawal({
          coop: cooperativeDetails.id,
          amount: amount,
          OTP: values.code,
        });

        if (resp.data?.success) {
          onSuccess();
        }
      },
    });

  return (
    <form onSubmit={handleSubmit} className="flex flex-1 flex-col gap-4">
      <InformationCard
        info={
          <p className="text-sm">
            We sent a code to{" "}
            <span className="text-pry-green-200">
              {maskEmail(profile?.Email ?? "")}
            </span>{" "}
            and{" "}
            <span className="text-pry-green-200">
              {maskPhoneNumber(profile?.PhoneNumber ?? "")}
            </span>
          </p>
        }
        innerClassName="!items-start md:!min-w-full"
        hasIcon={false}
        variant="green"
        size="mini"
      />

      <TextInput
        type="text"
        name="code"
        value={values.code}
        placeholder={`Enter code`}
        onChange={handleChange}
        onBlur={handleBlur}
        hasIcon={false}
        autoComplete="off"
        errors={touched?.code && errors?.code ? errors?.code : ""}
        className="!mt-4"
      />

      <Button
        type="submit"
        className=""
        text="Proceed"
        loading={initiatingWithdrawal}
        disabled={initiatingWithdrawal}
      />
    </form>
  );
};
